var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbleShapeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:\"#replaceMe\";}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.2,127.9l-6-19c3.7-7,5.8-15,5.8-23.4v-31C136,26.7,113.3,4,85.5,4h-31C26.7,4,4,26.7,4,54.5v31 C4,113.3,26.7,136,54.5,136h31c8.5,0,16.4-2.1,23.4-5.8l19,6c0.7,0.2,1.3,0.3,2,0.3c2.1,0,4.1-1,5.3-2.7 C136.4,132.1,136.8,129.9,136.2,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.5,133h-31C28.3,133,7,111.7,7,85.5v-31C7,28.3,28.3,7,54.5,7h31C111.7,7,133,28.3,133,54.5v31 C133,111.7,111.7,133,85.5,133z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleShapeShow);
export default __webpack_public_path__ + "static/media/BubbleShape_Show.62c55292ce6d46974fbe928358b039c3.svg";
export { ForwardRef as ReactComponent };